"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateFutureLeverageV2 = void 0;
const operators_1 = require("rxjs/operators");
const FutureAPI_1 = require("../../../../apis/FutureAPI");
const Assets_1 = require("../../../../component/Assets");
const factory_1 = require("../../SymbolTradeInfo/factory");
/**更新传入的币对的杠杆倍数 */
function updateFutureLeverageV2(symbol, leverage) {
    const params = {
        symbol: symbol,
        leverage: `${leverage}`,
    };
    return (0, FutureAPI_1.setFuturesLeverage)(params).pipe((0, operators_1.tap)(() => {
        (0, Assets_1.refreshAccountDetail)();
        (0, factory_1.refreshSymbolTradeInfo)({ symbol: symbol, leverage: Number(leverage) });
    }));
}
exports.updateFutureLeverageV2 = updateFutureLeverageV2;
